import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { preloadCriticalResources, registerSW } from "@/utils/performance-utils";

// Initialize performance optimizations
preloadCriticalResources();
registerSW();

createRoot(document.getElementById("root")!).render(<App />);
